import { Logo } from '@/components/brand/Logo';

import { LoginForm } from '../components/LoginForm';

/**
 * Écran de connexion.
 *
 * Toutes les mesures verticales sont en `clamp(min, Nvh, max)` : sur un écran
 * de 1080 px elles prennent leur valeur maximale (la maquette), sur un portable
 * de 768 px elles se resserrent jusqu'au minimum. C'est ce qui permet de tenir
 * dans la fenêtre sans défilement, plutôt que de rogner des éléments.
 */
export const LoginPage = () => (
  <div className="flex min-h-0 flex-1 flex-col">
    <Logo className="mb-[clamp(1rem,4vh,3rem)] shrink-0" />

    {/* Bloc centré dans l'espace restant, à largeur de lecture confortable. */}
    <div className="flex min-h-0 flex-1 flex-col justify-center">
      <div className="w-full max-w-[478px]">
        {/* La famille, la couleur (bleu profond) et l'équilibrage des lignes
            viennent de la règle `h1..h6` de `index.css` : ne sont surchargés
            ici que le corps, l'interligne, la graisse et l'approche, propres
            à ce titre d'accueil. */}
        <h1 className="text-[clamp(2rem,4.4vh,3.25rem)] leading-[1.08] font-semibold tracking-[-0.03em]">
          Bon retour
        </h1>
        <p className="text-ink-600 mt-[clamp(0.5rem,1.4vh,1rem)] text-[clamp(0.9375rem,1.8vh,1.0625rem)] leading-snug">
          Connectez-vous à votre espace et continuez
          <br className="hidden sm:inline" /> à faire avancer vos recrutements.
        </p>

        <div className="mt-[clamp(1.25rem,3.4vh,2.5rem)]">
          <LoginForm />
        </div>
      </div>
    </div>

    {/* L'année est calculée et non figée : un pied de page daté de l'an passé
        est le premier signe d'un site laissé à l'abandon. */}
    <p className="text-ink-400 mt-[clamp(0.75rem,2vh,1.75rem)] shrink-0 text-xs">
      © {new Date().getFullYear()} ubeefy. Tous droits réservés.
    </p>
  </div>
);
